/**
 * Banner component to display important information about quantity data display changes
 * Only displays for NA (North America) sites (region_id === 1)
 */

import React from "react"
import PropTypes from "prop-types"
import Box from "@amzn/meridian/box"
import Text from "@amzn/meridian/text"
import Row from "@amzn/meridian/row"
import Column from "@amzn/meridian/column"
import Icon from "@amzn/meridian/icon"
import infoTokens from "@amzn/meridian-tokens/base/icon/info"

const QuantityDisplayBanner = ({ region_id }) => {
    // Only show banner for NA sites (region_id === 1)
    if (region_id !== 1) {
        return null
    }

    return (
        <Box
            backgroundColor="orange-50"
            borderColor="orange-300"
            borderWidth="200"
            borderRadius="300"
            spacingInset="100"
            boxShadow="100"
        >
            <Row spacing="300" alignmentVertical="start">
                <Icon tokens={infoTokens} color="orange-600" size="300" />
                <Column spacing="200" width="fill">
                    <Text type="h400" color="orange-800">
                        Attention: Site Migration
                    </Text>
                    <Text type="b200" color="orange-700" lineHeight="relaxed">
                        MM will be transitioning to a new link in coming days. Users will be automatically redirected to the new version.
                    </Text>
                    <Text type="b200" color="orange-700" lineHeight="relaxed">
                        Views and functionality will remain the same. No action needed from users.
                    </Text>
                </Column>
            </Row>
        </Box>
    )
}

QuantityDisplayBanner.propTypes = {
    region_id: PropTypes.number.isRequired
}

export default QuantityDisplayBanner
